function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

async function submitToWaitlist(email: string, source: string): Promise<boolean> {
  const response = await fetch('/api/waitlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, source })
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || `Server error: ${response.status}`)
  }

  return true
}

function initForm(formId: string, successId: string): void {
  const form = document.getElementById(formId) as HTMLFormElement
  const successMessage = document.getElementById(successId)

  if (!form || !successMessage) return

  // Derive source from form ID: "waitlist-form-hero" -> "hero"
  const source = formId.replace('waitlist-form-', '')

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    const emailInput = form.querySelector('input[type="email"]') as HTMLInputElement
    const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement

    if (!emailInput || !submitButton) return

    const email = emailInput.value.trim()

    // Validate email
    if (!isValidEmail(email)) {
      emailInput.classList.add('border-red-500')
      emailInput.focus()
      return
    }

    emailInput.classList.remove('border-red-500')

    // Show loading state
    const originalButtonText = submitButton.textContent
    submitButton.disabled = true
    submitButton.textContent = 'Joining...'

    try {
      await submitToWaitlist(email, source)

      // Hide form and show success message
      form.classList.add('hidden')
      successMessage.classList.remove('hidden')
    } catch (error) {
      console.error('Waitlist submission error:', error)

      const message = error instanceof Error && error.message.includes('Too many')
        ? 'Too many attempts'
        : 'Try again'

      submitButton.textContent = message
      submitButton.classList.add('bg-red-500')

      setTimeout(() => {
        submitButton.textContent = originalButtonText
        submitButton.classList.remove('bg-red-500')
        submitButton.disabled = false
      }, 2000)
    }
  })

  // Remove error styling on input
  const emailInput = form.querySelector('input[type="email"]') as HTMLInputElement
  if (emailInput) {
    emailInput.addEventListener('input', () => {
      emailInput.classList.remove('border-red-500')
    })
  }
}

export function initWaitlistForms(): void {
  // Initialize both waitlist forms (hero and CTA)
  initForm('waitlist-form-hero', 'waitlist-success-hero')
  initForm('waitlist-form-cta', 'waitlist-success-cta')
}
